import React from 'react';
import SectionTwo from '../sections/section2-p2';
import './Properties-list.css'
import Header from '../components/layout/header';
import Sec1p2 from '../sections/sec1-p2';
import Footerr from '../components/layout/footer';


const Propertieslist = () => {
    return ( 
        <>
        <Header homeActive="unactive" propertiesActive="active" contactActive="unactive" />
        <main>
            <Sec1p2 />
            <SectionTwo />
        </main>
        <Footerr />
     </>
     );
}
 
export default Propertieslist;